(function () {
	'use strict';

	angular
		.module('wizard-english-test.services')
		.service('LeadService', LeadService)

	/** @ngInject */
	function LeadService(HttpService) {
		const LeadService = {
			post,
			put
		};

		return LeadService;

		function post(data) {
			return HttpService.post('/leads', data);
		}

		function put(data) {
			return HttpService.put('/leads', data);
		}
	}
}());